import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Auth, signOut } from '@angular/fire/auth';
import { GuardUserCacheService } from '../services/guard-user-cache.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly auth: Auth,
    private readonly router: Router,
    private readonly guardUserCache: GuardUserCacheService,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const { firebaseUser, userData } = await this.guardUserCache.getSnapshot();

    if (!firebaseUser) {
      return this.router.createUrlTree(['/auth/login']);
    }

    try {
      if (!userData) {
        this.guardUserCache.clear();
        await signOut(this.auth).catch(() => undefined);
        localStorage.removeItem('userData');
        return this.router.createUrlTree(['/auth/login']);
      }

      const status = String(userData?.status || '').trim().toLowerCase();

      if (status !== 'approved') {
        this.guardUserCache.clear();
        await signOut(this.auth).catch(() => undefined);
        localStorage.removeItem('userData');
        return this.router.createUrlTree(['/auth/login']);
      }

      return true;
    } catch (error) {
      console.error('Authentication guard validation failed:', error);
      this.guardUserCache.clear();
      await signOut(this.auth).catch(() => undefined);
      localStorage.removeItem('userData');
      return this.router.createUrlTree(['/auth/login']);
    }
  }
}
